import { render, staticRenderFns } from "./lcsjThemeConfig.vue?vue&type=template&id=d71326e8&scoped=true"
import script from "./lcsjThemeConfig.vue?vue&type=script&lang=js"
export * from "./lcsjThemeConfig.vue?vue&type=script&lang=js"
import style0 from "./lcsjThemeConfig.vue?vue&type=style&index=0&id=d71326e8&prod&scoped=true&lang=css"
import style1 from "./lcsjThemeConfig.vue?vue&type=style&index=1&id=d71326e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71326e8",
  null
  
)

export default component.exports